export default {"src":"/_next/static/media/user-avatar.875276d5.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};